var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.989 2.148a1 1 0 10-1.978-.296L8.24 7H5a1 1 0 100 2h2.939l-.9 6H4a1 1 0 000 2h2.739l-.728 4.852a1 1 0 001.978.296L8.76 17h4.978l-.728 4.852a1 1 0 101.978.296L15.76 17H19a1 1 0 100-2h-2.939l.9-6H20a1 1 0 100-2h-2.739l.728-4.852a1 1 0 10-1.978-.296L15.24 7H10.26l.728-4.852zM14.039 15l.9-6H9.96l-.9 6h4.978z"
  })));
}
export default SvgHash;